import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GameStateEnum } from "interfaces/game";
import { Lobby } from "interfaces/lobby";

export interface LobbyState {
  lobby: Lobby | null;
}

const initialState: LobbyState = {
  lobby: null,
};

const lobbySlice = createSlice({
  name: "lobbyReducer",
  initialState,
  reducers: {
    setLobby: (state, action: PayloadAction<Lobby | null>) => {
      state.lobby = action.payload;
    },
    setLobbyId: (state, action: PayloadAction<string | null>) => {
      if (state.lobby) state.lobby.id = action.payload;
    },
    setLobbyState: (state, action: PayloadAction<GameStateEnum>) => {
      if (state.lobby) state.lobby.state = action.payload;
    },
  },
});

export const { setLobby, setLobbyId, setLobbyState } = lobbySlice.actions;
export default lobbySlice.reducer;
